exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fc-event-title {\n    font-weight: 500;\n    padding: 3px 5px !important;\n}\n.fc-event-main-frame{\n    cursor: pointer;\n}\n.fc-view-harness {\n    background: #fff !important;\n}\n.fc-view-harness a {\n    color: #333 !important;\n}\n.fc-event-main {\n    background: #ffee00 !important;\n    border-radius: 5px !important;\n}\n", ""]);

// exports
